/* eslint camelcase: 0 */

import { PermissionsInfoModel as Data } from '@/typings/api/PermissionsInfoModel'
import { Model, createMessages } from '@/helpers/Model'


export class PermissionsInfoModelModel extends Model<Data> {
  public static readonly page_title = createMessages({
    create: 'Добавить инфо модель',
    edit: 'Редактировать инфо модель',
    view: (data: PermissionsInfoModelModel) => 'Инфо модель «{name}»'
      .replace('{name}', data.name || '...'),
    list: 'Инфо-модели',
  });

  public static readonly modal_delete = createMessages({
    delete: (data: PermissionsInfoModelModel) => 'Удаление инфо модели «{name}»'
      .replace('{name}', data.name || '...'),
    delete_all: 'Удаление выбранных инфо моделей',
    delete_all_partly: 'Удаление части выбранных инфо моделей',
  });

  public static readonly response_success = createMessages({
    ...Model.response_success,
    delete_all_deny: 'Выбранные инфо модели нельзя удалить',
  });

  public static readonly response_error = createMessages({
    ...Model.response_error,
  });
}
